import { useState } from "react";

function ChatBot() {
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Hi 👋 How can I help you today?" }
  ]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sessionId] = useState(`session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    setMessages(prev => [...prev, userMessage]);
    setInput("");
    setIsLoading(true);

    try {
      // Your API Gateway endpoint with correct stage name
      const apiUrl = "https://zb9mncovu0.execute-api.us-west-2.amazonaws.com/dev/chat";
      console.log("Sending request to:", apiUrl);
      const res = await fetch(apiUrl, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ 
          message: input,
          sessionId: sessionId 
        }),
      });

      const data = await res.json();
      console.log("API Response:", data);

      let botReply = "";
      if (data.reply) {
        botReply = data.reply;
      } else if (data.message) {
        botReply = data.message;
      } else if (data.body) {
        const bodyData = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
        botReply = bodyData.reply || bodyData.message || JSON.stringify(bodyData);
      } else if (data.messages && data.messages.length > 0) {
        botReply = data.messages[0].content;
      } else {
        botReply = JSON.stringify(data);
      }

      setMessages(prev => [
        ...prev,
        { sender: "bot", text: botReply }
      ]);
    } catch (error) {
      console.error("Chat Error:", error);
      setMessages(prev => [
        ...prev,
        { sender: "bot", text: `Sorry, I encountered an error: ${error.message}. Please check the console for details.` }
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const styles = {
    pageContainer: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #e9d5ff 0%, #fce7f3 50%, #dbeafe 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    },
    mainContainer: {
      width: "100%",
      maxWidth: "800px"
    },
    chatContainer: {
      background: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(10px)",
      borderRadius: "24px",
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
      overflow: "hidden"
    },
    header: {
      background: "linear-gradient(135deg, #9333ea 0%, #ec4899 50%, #3b82f6 100%)",
      padding: "24px",
      color: "white",
      display: "flex",
      alignItems: "center",
      gap: "12px"
    },
    headerIcon: {
      background: "rgba(255, 255, 255, 0.2)",
      backdropFilter: "blur(10px)",
      padding: "12px",
      borderRadius: "50%",
      fontSize: "30px"
    },
    headerText: {
      display: "flex",
      flexDirection: "column"
    },
    headerTitle: {
      fontSize: "24px",
      fontWeight: "bold",
      margin: 0
    },
    headerSubtitle: {
      fontSize: "14px",
      opacity: 0.9,
      margin: 0
    },
    chatBox: {
      height: "500px",
      overflowY: "auto",
      padding: "24px",
      background: "linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(243, 232, 255, 0.3) 100%)",
      display: "flex",
      flexDirection: "column",
      gap: "16px"
    },
    messageContainer: {
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      animation: "fadeIn 0.3s ease-in"
    },
    messageContainerUser: {
      flexDirection: "row-reverse"
    },
    messageIcon: {
      padding: "8px",
      borderRadius: "50%",
      fontSize: "20px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
    },
    botIcon: {
      background: "linear-gradient(135deg, #ec4899 0%, #f97316 100%)"
    },
    userIcon: {
      background: "linear-gradient(135deg, #3b82f6 0%, #9333ea 100%)"
    },
    messageBubble: {
      maxWidth: "75%",
      padding: "12px 20px",
      borderRadius: "16px",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
    },
    botMessage: {
      background: "white",
      color: "#1f2937",
      borderTopLeftRadius: "4px",
      border: "1px solid #f3f4f6"
    },
    userMessage: {
      background: "linear-gradient(135deg, #3b82f6 0%, #9333ea 100%)",
      color: "white",
      borderTopRightRadius: "4px"
    },
    messageText: {
      fontSize: "14px",
      lineHeight: "1.6",
      margin: 0
    },
    loadingDots: {
      display: "flex",
      gap: "4px"
    },
    dot: {
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      animation: "bounce 1.4s infinite ease-in-out"
    },
    inputContainer: {
      padding: "24px",
      background: "rgba(255, 255, 255, 0.9)",
      backdropFilter: "blur(10px)",
      borderTop: "1px solid #f3f4f6"
    },
    inputWrapper: {
      display: "flex",
      gap: "12px",
      alignItems: "center"
    },
    input: {
      flex: 1,
      padding: "12px 20px",
      borderRadius: "25px",
      border: "2px solid #e9d5ff",
      fontSize: "14px",
      outline: "none",
      transition: "border-color 0.3s",
      background: "rgba(255, 255, 255, 0.8)"
    },
    sendButton: {
      background: "linear-gradient(135deg, #9333ea 0%, #ec4899 50%, #3b82f6 100%)",
      color: "white",
      padding: "12px 24px",
      borderRadius: "25px",
      border: "none",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.2s",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
    },
    sendButtonDisabled: {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  };

  return (
    <div style={styles.pageContainer}>
      <div style={styles.mainContainer}>
        {/* Chat Container */}
        <div style={styles.chatContainer}>
          {/* Header */}
          <div style={styles.header}>
            <div style={styles.headerIcon}>🤖</div>
            <div style={styles.headerText}>
              <h1 style={styles.headerTitle}>RoundBox AI Assistant</h1>
              <p style={styles.headerSubtitle}>Always here to help</p>
            </div>
          </div>

          {/* Chat Box */}
          <div style={styles.chatBox}>
            {messages.map((msg, i) => (
              <div
                key={i}
                style={{
                  ...styles.messageContainer,
                  ...(msg.sender === "user" ? styles.messageContainerUser : {})
                }}
              >
                <div
                  style={{
                    ...styles.messageIcon,
                    ...(msg.sender === "user" ? styles.userIcon : styles.botIcon)
                  }}
                >
                  {msg.sender === "user" ? "👤" : "🤖"}
                </div>
                <div
                  style={{
                    ...styles.messageBubble,
                    ...(msg.sender === "user" ? styles.userMessage : styles.botMessage)
                  }}
                >
                  <p style={styles.messageText}>{msg.text}</p>
                </div>
              </div>
            ))}
            
            {isLoading && (
              <div style={styles.messageContainer}>
                <div style={{...styles.messageIcon, ...styles.botIcon}}>🤖</div>
                <div style={{...styles.messageBubble, ...styles.botMessage}}>
                  <div style={styles.loadingDots}>
                    <div style={{...styles.dot, background: "linear-gradient(135deg, #9333ea, #ec4899)", animationDelay: "0ms"}}></div>
                    <div style={{...styles.dot, background: "linear-gradient(135deg, #ec4899, #f97316)", animationDelay: "150ms"}}></div>
                    <div style={{...styles.dot, background: "linear-gradient(135deg, #f97316, #facc15)", animationDelay: "300ms"}}></div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Input Box */}
          <div style={styles.inputContainer}>
            <div style={styles.inputWrapper}>
              <input
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyPress={handleKeyPress}
                onFocus={(e) => e.target.style.borderColor = "#9333ea"}
                onBlur={(e) => e.target.style.borderColor = "#e9d5ff"}
                placeholder="Type your message..."
                style={styles.input}
                disabled={isLoading}
              />
              <button
                onClick={sendMessage}
                disabled={isLoading || !input.trim()}
                style={{
                  ...styles.sendButton,
                  ...(isLoading || !input.trim() ? styles.sendButtonDisabled : {})
                }}
                onMouseEnter={(e) => {
                  if (!isLoading && input.trim()) {
                    e.target.style.transform = "scale(1.05)";
                    e.target.style.boxShadow = "0 8px 12px rgba(0, 0, 0, 0.2)";
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
                }}
              >
                Send ✈️
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
}

export default ChatBot;